/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

angular
	.module('ticketspaceApp')
	//### addStatic(constructor, statics)
	// Adds the list of static properties to the constructor and prototype of the passed in object
	// * constructor - a function intended to be called with new
	// * statics - an object containing "things" to be added. Uses standard copy rules.
	// So functions and primitives are usually safe, objects will maintain references.
	.factory('addStatic', [
		function () {
			const logger = LoggerServiceFactory.create('addStatic');
			function addProps(target, src) {
				for (let key in src) {
					//add has own check
					if (src.hasOwnProperty(key)) {
						if (!target[key]) {
							target[key] = src[key];
						}
					}
				}
			}
			function add(constructor, statics) {
				if (!constructor || !statics) {
					logger.log('nothing to do...');
					return;
				}
				//consider object/function checks
				addProps(constructor, statics);
				addProps(constructor.prototype, statics);
			}

			return {
				all: add,
				direct: addProps,
			};
		},
	]);
